import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Helmet from "react-helmet";
// import TeamImage from './TeamImage.png'
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { SocialView } from "../SocialView/SocialView";
import { FooterNote } from "../FooterLinks/FooterNote";
import {
  fetchMenusIfNeeded,
  fetchFestProgIfNeeded,
  SERVER_BASE_URL,
  CLIENT_BASE_URL
} from "../../actions";

export class FestProgramView extends React.Component {
  componentDidMount(p) {
    const { dispatch } = this.props;
    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
    dispatch(fetchFestProgIfNeeded());
  }

  componentWillReceiveProps(nextProps) {
    const { selectedScope, dispatch } = nextProps;
    if (selectedScope !== this.props.selectedScope) {
      dispatch(fetchMenusIfNeeded(selectedScope));
    }
  }

  renderAttachment(attachments) {
    const num_items = attachments.length;

    return attachments.map((info, i) => {
      const extraClass = i === num_items - 1 ? "row" : "row pressrelease";
      const download_url = `${SERVER_BASE_URL}/api/download_attach/${info.id}`;

      return (
        <div key={i} className={extraClass}>
          <div className="col-sm-8 col-md-6 col-lg-6">
            <p
              className="title"
              dangerouslySetInnerHTML={{ __html: info.title }}
            />
            <div>
              <a href={download_url}>
                <button>
                  <i className="glyphicon glyphicon-download-alt" /> DOWNLOAD
                </button>
              </a>
            </div>
            <p
              className="desc"
              dangerouslySetInnerHTML={{ __html: info.description }}
            />
          </div>
        </div>
      );
    });
  }

  render() {
    const { menus, festprogram, dispatch } = this.props;
    const bottom_menus = menus.bottom || [];
    const top_menus = menus.top || [];

    // console.log('festprogram...', festprogram)

    if (typeof festprogram === "undefined" || !festprogram.length) {
      return (
        <div>
          <HeaderView top_menus={top_menus} dispatch={dispatch} />
          <div id="presskit-view" className="team-view">
            <div className="row">
              <div className="col-md-12 no-pad text-left">
                <p className="left-tag">Programa</p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <Helmet
          title="Programação"
          meta={[
            {
              name: "description",
              content:
                "A Festa do Cinema Italiano é o acontecimento mais importante em Portugal dedicado à cultura italiana e um dos festivais cinematográficos mais apreciados no país. Organizado pela Associação Il Sorpasso desde 2008, a Festa do Cinema Italiano ampliou também a sua presença internacionalmente com extensões e programação a decorrer em países como Brasil, Angola e Moçambique."
            },
            {
              property: "og:image",
              content:
                "https://festadocinemaitaliano.com/admin/assets/img/logo.png"
            },
            { property: "og:title", content: "Programação" },
            { property: "og:type", content: "article" },
            {
              property: "og:url",
              content: CLIENT_BASE_URL + "/programa"
            }
          ]}
        />
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div id="presskit-view" className="team-view text-left">
          <div className="row">
            <div className="col-md-12 no-pad">
              <p className="left-tag">Programa</p>
            </div>
          </div>
          <div className="main-block">
            <div className="row">
              <div className="col-sm-12">
                <p
                  className="desc"
                  dangerouslySetInnerHTML={{
                    __html: festprogram[0].description
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                {this.renderAttachment(festprogram[0].attachments)}
              </div>
            </div>
          </div>
        </div>

        <FooterLinks bottom_menus={bottom_menus} />
        <SocialView customclass="lite" />
        <FooterNote />
      </div>
    );
  }
}

FestProgramView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  menus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  festprogram: PropTypes.array.isRequired,
  selectedScope: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  const { getMenus, getFestProg, selectedScope } = state;

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const { isFetchingFestProg, items: festprogram } = getFestProg["all"] || {
    isFetchingFestProg: true,
    items: []
  };

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    isFetchingFestProg,
    festprogram,
    selectedScope
  };
}

export default connect(mapStateToProps)(FestProgramView);



// WEBPACK FOOTER //
// ./src/views/AboutView/FestProgramView.js